import { AlertCircle, X, LifeBuoy } from "lucide-react";
import { useEffect, useState } from "react";
import api from "../lib/api";

// Gentle, non-diagnosing check-in. Resurfaces support after several tough days.
export const CheckinPrompt = () => {
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => { api.get("/checkin/status").then(({ data }) => setStatus(data)).catch(() => {}); }, []);

  if (!status?.needs_checkin || dismissed) return null;

  return (
    <div data-testid="checkin-prompt" className="relative flex gap-4 rounded-2xl border border-[#8FB8DE]/50 bg-[#8FB8DE]/10 p-5">
      <button onClick={() => setDismissed(true)} data-testid="checkin-dismiss" className="absolute right-3 top-3 text-muted-foreground hover:text-[#2C363F]"><X className="h-4 w-4" /></button>
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-[#2C4763]"><AlertCircle strokeWidth={1.8} className="h-5 w-5" /></div>
      <div>
        <h3 className="font-head font-semibold text-[#2C363F]">Checking in with you 💙</h3>
        <p className="mt-1 text-sm text-[#2C4763]">It looks like the last few days have been tough. That's completely okay — hard stretches are part of many journeys, and you're still moving forward. If you'd like someone to talk to, support is here whenever you need it.</p>
        <button onClick={() => document.querySelector('[data-testid="crisis-button"]')?.click()} data-testid="checkin-help" className="mt-3 inline-flex items-center gap-2 rounded-full bg-[#D96C5B] px-4 py-2 text-sm font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5">
          <LifeBuoy className="h-4 w-4" /> See support options
        </button>
      </div>
    </div>
  );
};
